/**
 * TermsSection Component - Shopify Sales Channel Requirement
 *
 * Displays links to Terms of Service and Privacy Policy.
 * Uses Polaris Layout.AnnotatedSection as required by Shopify.
 */

import React from 'react';
import {
  Layout,
  Card,
  BlockStack,
  Link
} from '@shopify/polaris';

export default function TermsSection() {
  return (
    <Layout.AnnotatedSection
      title="Terms & Conditions"
      description="Legal terms for using InClub."
    >
      <Card>
        <BlockStack gap="2">
          <Link url="https://inclub.vip/terms-brands" external>
            Terms of Service
          </Link>
          <Link url="https://inclub.vip/privacy" external>
            Privacy Policy
          </Link>
        </BlockStack>
      </Card>
    </Layout.AnnotatedSection>
  );
}
